import { ColumnDef } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import { SuperAdminOrderListItemDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';
import {
    formatBoolean,
    formatDateTime,
    formatNavValue,
} from '@/features/superAdmin/features/data/shared/utils/superAdminDataFormatters';

export const useSuperAdminOrdersPageColumns = () => {
    const { t } = useTranslation();

    const columns: ColumnDef<SuperAdminOrderListItemDto>[] = [
        { accessorKey: 'id', header: t('superAdmin.data.columns.id') },
        { accessorKey: 'documentNumber', header: t('superAdmin.data.columns.documentNumber') },
        { accessorKey: 'documentDate', header: t('superAdmin.data.columns.documentDate'), cell: ({ row }) => formatDateTime(row.original.documentDate) },
        { accessorKey: 'tenantName', header: t('superAdmin.data.columns.tenant'), cell: ({ row }) => formatNavValue(row.original.tenantId, row.original.tenantName) },
        { accessorKey: 'hotelName', header: t('superAdmin.data.columns.hotel'), cell: ({ row }) => formatNavValue(row.original.hotelId, row.original.hotelName) },
        { accessorKey: 'apartmentName', header: t('superAdmin.data.columns.room'), cell: ({ row }) => formatNavValue(row.original.apartmentId, row.original.apartmentName) },
        { accessorKey: 'ownerName', header: t('superAdmin.data.columns.owner'), cell: ({ row }) => formatNavValue(row.original.ownerId, row.original.ownerName) },
        { accessorKey: 'authorName', header: t('superAdmin.data.columns.author'), cell: ({ row }) => formatNavValue(row.original.authorId, row.original.authorName) },
        { accessorKey: 'serviceName', header: t('superAdmin.data.columns.service'), cell: ({ row }) => formatNavValue(row.original.serviceId, row.original.serviceName) },
        { accessorKey: 'status', header: t('superAdmin.data.columns.status') },
        { accessorKey: 'deliveryDate', header: t('superAdmin.data.columns.deliveryDate'), cell: ({ row }) => formatDateTime(row.original.deliveryDate) },
        { accessorKey: 'paymentMethod', header: t('superAdmin.data.columns.paymentMethod') },
        { accessorKey: 'totalAmount', header: t('superAdmin.data.columns.totalAmount') },
        { accessorKey: 'deletionMark', header: t('superAdmin.data.columns.deletionMark'), cell: ({ row }) => formatBoolean(row.original.deletionMark) },
        { accessorKey: 'syncStatus', header: t('superAdmin.data.columns.syncStatus') },
        { accessorKey: 'syncAction', header: t('superAdmin.data.columns.syncAction') },
        { accessorKey: 'externalId', header: t('superAdmin.data.columns.externalId') },
        { accessorKey: 'version', header: t('superAdmin.data.columns.version') },
    ];

    return columns;
};

export const orderLineNestedColumns: ColumnDef<SuperAdminOrderListItemDto['lines'][number]>[] = [
    { accessorKey: 'id', header: 'Id' },
    { accessorKey: 'orderItemName', header: 'OrderItem', cell: ({ row }) => formatNavValue(row.original.orderItemId, row.original.orderItemName) },
    { accessorKey: 'quantity', header: 'Quantity' },
    { accessorKey: 'price', header: 'Price' },
    { accessorKey: 'amount', header: 'Amount' },
];
